/*
 *
 * PayToCard Actions
 *
 * @version 1.0.0
 * @author Andrea Esposito
 * @since 01-Oct-2026
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_GET_PAY_TO_CARD_TERMINAL_ID_LIST: '@@PayToCard/get_pay_to_card_terminal_id_list',
  DO_SET_PAY_TO_CARD_STEP: '@@PayToCard/set_pay_to_card_step',
  DO_GENERATE_PAY_TO_CARD: '@@PayToCard/generate_pay_to_card',
  DO_RESET_PTC_GENERATE_RESULT: '@@PayToCard/reset_ptc_generate_result',
  DO_PTC_SEND_DIRECT_EMAIL_SMS: '@@PayToCard/ptc_send_direct_email_sms',
  DO_RETRIEVE_PTC_QRCODE: '@@PayToCard/retrieve_ptc_qrcode',
  DO_SET_QR_CODE_TOAST_MESSAGE: '@@PayToCard/set_qr_code_toast_message',
  // @generator action:route:type
  ...createRequestTypes('@@PayToCard', 'GET_PAY_TO_CARD_TERMINAL_ID_LIST'),
  ...createRequestTypes('@@PayToCard', 'GENERATE_PAY_TO_CARD'),
  ...createRequestTypes('@@PayToCard', 'GENERATE_PTC_DIRECT_EMAIL_SMS'),
  ...createRequestTypes('@@PayToCard', 'GENERATE_PTC_QRCODE')
  // @generator action:route:type:request
}

// @generator action:route:request
export const getPayToCardTerminalIdList = new MakeRequest('PayToCard', 'get_pay_to_card_terminal_id_list')
export const generatePayToCard = new MakeRequest('PayToCard', 'generate_pay_to_card')
export const generatePtcDirectEmailSms = new MakeRequest('PayToCard', 'generate_ptc_direct_email_sms')
export const generatePtcQrcode = new MakeRequest('PayToCard', 'generate_ptc_qrcode')

// @generator action:route
export const doGetPayToCardTerminalIdList = (payload) =>
  createAction(actionTypes.DO_GET_PAY_TO_CARD_TERMINAL_ID_LIST, { payload })
export const doSetPayToCardStep = (payload) => createAction(actionTypes.DO_SET_PAY_TO_CARD_STEP, { payload })
export const doGeneratePayToCard = (payload) => createAction(actionTypes.DO_GENERATE_PAY_TO_CARD, { payload })
export const doResetPtcGenerateResult = (payload) => createAction(actionTypes.DO_RESET_PTC_GENERATE_RESULT, { payload })
export const doPtcSendDirectEmailSms = (payload) => createAction(actionTypes.DO_PTC_SEND_DIRECT_EMAIL_SMS, { payload })
export const doRetrievePtcQrcode = (payload) => createAction(actionTypes.DO_RETRIEVE_PTC_QRCODE, { payload })
export const doSetQrCodeToastMessage = (payload) => createAction(actionTypes.DO_SET_QR_CODE_TOAST_MESSAGE, { payload })
